export function ExtentionSpliter(argument){

    let extention=argument.substring(argument.lastIndexOf("."));
    return extention;
}